<template>
  <div class id="BuyCar">
    <div class="headerBox">
      <div class="search">
        <van-search
          v-model="searchBoxBoby.keyword"
          @search="onSearchs"
          placeholder="搜索品牌/车型"
          input-align="center"
        />
      </div>
      <div class="header" @click="showPopup">
        <span>{{carmodel}}</span>
        <!-- <img src="static/image/up_down.png" alt /> -->
      </div>
    </div>
    <div class="screen">
      <ul>
        <li @click="onShowSearchBox('sort')">
          <span>智能筛选</span>
          <img src="static/image/up_down.png" alt />
          <ul class v-show="conditional=='sort'">
            <div class="line"></div>
            <li @click="onSearch(0)">
              <div class="box">
                <span>默认排序</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 0" alt />
              </div>
            </li>
            <li @click="onSearch(1)">
              <div class="box">
                <span>价格最低</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 1" alt />
              </div>
            </li>
            <li>
              <div class="box" @click="onSearch(2)">
                <span>价格最高</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 2" alt />
              </div>
            </li>
            <li>
              <div class="box" @click="onSearch(4)">
                <span>车龄最短</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 4" alt />
              </div>
            </li>
            <li>
              <div class="box" @click="onSearch(3)">
                <span>车龄最长</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 3" alt />
              </div>
            </li>
            <li>
              <div class="box" @click="onSearch(6)">
                <span>里程最少</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 5" alt />
              </div>
            </li>
            <li>
              <div class="box" @click="onSearch(5)">
                <span>里程最多</span>
                <img src="static/image/Choice.png" v-show="this.searchBoxBoby.sort == 6" alt />
              </div>
            </li>
          </ul>
        </li>
        <li @click="onShowSearchBox('brand')">
          <span>品牌</span>
          <img src="static/image/up_down.png" alt />
        </li>
        <li @click="onShowSearchBox('price')">
          <span>价格</span>
          <img src="static/image/up_down.png" alt />
          <ul class v-show="conditional=='price'">
            <li style="height:auto;" @click.stop>
              <div class="line"></div>
              <div class="box money">
                <van-row gutter="10">
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:-1,maxPrice:-1})"
                    @click="onSearch({minPrice:-1,maxPrice:-1})"
                  >不限价格</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:-1,maxPrice:5})"
                    @click="onSearch({minPrice:-1,maxPrice:5})"
                  >5万以下</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:5,maxPrice:10})"
                    @click="onSearch({minPrice:5,maxPrice:10})"
                  >5-10万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:10,maxPrice:15})"
                    @click="onSearch({minPrice:10,maxPrice:15})"
                  >10-15万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:15,maxPrice:20})"
                    @click="onSearch({minPrice:15,maxPrice:20})"
                  >15-20万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:20,maxPrice:25})"
                    @click="onSearch({minPrice:20,maxPrice:25})"
                  >20-25万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:25,maxPrice:30})"
                    @click="onSearch({minPrice:25,maxPrice:30})"
                  >25-30万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:30,maxPrice:50})"
                    @click="onSearch({minPrice:30,maxPrice:50})"
                  >30-50万</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({minPrice:50,maxPrice:-1})"
                    @click="onSearch({minPrice:50,maxPrice:-1})"
                  >50万以上</van-col>
                </van-row>
                <div class="custom">
                  <h1>
                    自定义价格
                    <em>(万元)</em>
                  </h1>
                  <input type="text" placeholder="请输入金额" v-model="customInput.minPrice" />
                  <span></span>
                  <input type="text" placeholder="请输入金额" v-model="customInput.maxPrice" />
                  万
                  <button @click.stop="onOk('price')">确定</button>
                </div>
              </div>
            </li>
          </ul>
          <div class="clearfix"></div>
        </li>
        <li class="screenBox" @click="onShowSearchBox('multiselect')">
          <span>筛选</span>
          <img src="static/image/up_down.png" alt />
          <ul class v-show="conditional=='multiselect'">
            <div class="line"></div>
            <div class="liBox">
              <li style="height:auto;" @click.stop>
                <van-row gutter="10">
                  <h1>变速箱</h1>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:0},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:0})"
                  >不 限</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:1},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:1})"
                  >MT-手动</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:2},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:2})"
                  >AT-自动</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:3},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:3})"
                  >AMT-机械式</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:4},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:4})"
                  >CVT-无极</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:5},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:5})"
                  >DSG-双离合</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:6},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:6})"
                  >手自一体</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:7},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:7})"
                  >电动车单速</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carGearboxType:8},'carGearboxType')"
                    @click.stop="onSearch({carGearboxType:8})"
                  >其他</van-col>
                </van-row>
              </li>
              <li style="height:auto;" @click.stop>
                <div class="line"></div>
                <van-row gutter="10">
                  <h1>车型结构</h1>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:0},'carBodyType')"
                    @click.stop="onSearch({carBodyType:0})"
                  >不 限</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:1},'carBodyType')"
                    @click.stop="onSearch({carBodyType:1})"
                  >SUV</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:2},'carBodyType')"
                    @click.stop="onSearch({carBodyType:2},'carBodyType')"
                  >MPV</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:3},'carBodyType')"
                    @click.stop="onSearch({carBodyType:3},'carBodyType')"
                  >敞篷车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:4},'carBodyType')"
                    @click.stop="onSearch({carBodyType:4},'carBodyType')"
                  >跑车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:5},'carBodyType')"
                    @click.stop="onSearch({carBodyType:5},'carBodyType')"
                  >两厢车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:6},'carBodyType')"
                    @click.stop="onSearch({carBodyType:6},'carBodyType')"
                  >三厢车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:7},'carBodyType')"
                    @click.stop="onSearch({carBodyType:7},'carBodyType')"
                  >旅行车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:8},'carBodyType')"
                    @click.stop="onSearch({carBodyType:8},'carBodyType')"
                  >皮 卡</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:9},'carBodyType')"
                    @click.stop="onSearch({carBodyType:9},'carBodyType')"
                  >单 厢</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:10},'carBodyType')"
                    @click.stop="onSearch({carBodyType:10},'carBodyType')"
                  >两厢半</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carBodyType:11},'carBodyType')"
                    @click.stop="onSearch({carBodyType:11},'carBodyType')"
                  >其 他</van-col>
                </van-row>
              </li>
              <li style="height:auto;" @click.stop>
                <div class="line"></div>
                <van-row gutter="10">
                  <h1>车辆类型</h1>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({type:0},'type')"
                    @click.stop="onSearch({type:0})"
                  >不 限</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({type:1},'type')"
                    @click.stop="onSearch({type:1})"
                  >新 车</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({type:2},'type')"
                    @click.stop="onSearch({type:2})"
                  >二手车</van-col>
                </van-row>
              </li>
              <li style="height:auto;" @click.stop>
                <div class="line"></div>
                <van-row gutter="10">
                  <h1>车 龄</h1>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:-1,carAgeEnd:-1},'carAge')"
                    @click.stop="onSearch({carAgeStart:-1,carAgeEnd:-1})"
                  >不 限</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:0,carAgeEnd:1},'carAge')"
                    @click.stop="onSearch({carAgeStart:0,carAgeEnd:1})"
                  >一年以内</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:1,carAgeEnd:3},'carAge')"
                    @click.stop="onSearch({carAgeStart:1,carAgeEnd:3})"
                  >1-3年</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:3,carAgeEnd:5},'carAge')"
                    @click.stop="onSearch({carAgeStart:3,carAgeEnd:5})"
                  >3-5年</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:5,carAgeEnd:8},'carAge')"
                    @click.stop="onSearch({carAgeStart:5,carAgeEnd:8})"
                  >5-8年</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:8,carAgeEnd:10},'carAge')"
                    @click.stop="onSearch({carAgeStart:8,carAgeEnd:10})"
                  >8-10年</van-col>
                  <van-col
                    span="8"
                    :class="mapPriceClassName({carAgeStart:10,carAgeEnd:-1},'carAge')"
                    @click.stop="onSearch({carAgeStart:10,carAgeEnd:-1})"
                  >10年以上</van-col>
                </van-row>
              </li>
              <li style="height:auto;" @click.stop>
                <div class="box">
                  <van-button class="cor75" square @click.stop="onReset" color="#f5f5f5">重 置</van-button>
                  <van-button square @click="onOk" color="#009BFF">确 定</van-button>
                  <!-- <div>
                  <button @click.stop="onReset">重置</button>
                </div>
                <div>
                  <button @click="onOk">确定</button>
                  </div>-->
                </div>
              </li>
            </div>
          </ul>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
    <div class="new_car">
      <div class="line-5"></div>
      <div class="new_car_list">
        <ul
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="50"
        >
          <li v-for="(item,key) in resList" v-bind:key="key" @click="linkCarInfo(item)">
            <div class="car_img float-left">
              <img :src="item.imgPath" />
            </div>
            <div class="car_titel float-right">
              <h1>{{item.carModelName}}</h1>
              <p>
                <em>{{item.firstLicenseDate.substring(0, 7)}}月上牌 / {{item.mileage}}万公里 / {{item.cityName}}</em>
              </p>
              <h2>
                <span>{{item.price}}万</span>
                <!-- <em>首付:{{item.price*0.3|number}}</em>万
                <em style="padding-left:5px;"></em> -->
              </h2>
              <!-- 月供<em>{{item.price*0.7/36*10000|money}}</em>元 -->
            </div>
            <div class="clearfix"></div>
          </li>
        </ul>
        <!-- <div
          style="display:flex;height:80vh;justify-content:center;align-content:center"
          v-show="( resList.length==0)"
        >
          <span v-show="loading==false">暂无数据</span>
        </div>-->
      </div>
    </div>
    <!-- <div class="footer">
            <ul>
                <li style="width:50%;">
                    <router-link to="BuyCar">
                        <img src="static/image/buy_car_on.png" alt="">
                        <span class="c1">买车</span>
                    </router-link>
                </li>
                <li style="width:50%;">
                    <router-link to="SellCar">
                        <img src="static/image/sell_car_off.png" alt="">
                        <span>卖车</span>
                    </router-link>
                </li>
            </ul>
    </div>-->
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-area
        title="选择城市"
        :columns-num="2"
        :area-list="areaList"
        @change="onProvince"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { API_GET, API_POST, getLocation, URI } from "@/apiConfig";
import areaList from "../assets/area/area.js";
import axios from "axios";
export default {
  name: "BuyCar",
  computed: {},
  data() {
    return {
      loading: false,
      areaList,
      province_list: {},
      city_list: {},
      county_list: {},
      carmodel: "全国",
      cityId: "",
      show: false,
      body: {
        pageNo: 1,
        pageSize: 10
        // provinceId: 90,
      },
      option: [
        { text: "全部商品", value: 0 },
        { text: "新款商品", value: 1 },
        { text: "活动商品", value: 2 }
      ],
      value: 0,
      indexList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      conditional: "", // 当前点击是哪个排序选择框
      searchBoxBoby: {}, // 保存当前搜索框已选的条件
      customInput: {}, // 自定义价格
      resList: [], // 返回数据列表
      resTotal: 0,
      lastPages: 0, // 最后一页是多少页
      phone: this.$route.query.phone
    };
  },
  mounted() {
    if (this.$route.query.carBrandId) {
      // carBrandId 品牌车型id，目前只能从车的品牌页过，如果有值，代表有选择品牌回调，则把品牌加入搜索条件中
      this.body.carBrandId = this.$route.query.carBrandId;
    } else {
      delete this.body.carBrandId;
    }
    this.fetchData();
  },
  methods: {
    getLocalPosition: function() {},
    onConfirm() {
      this.$refs.item.toggle();
    },

    // 弹出层显示
    showPopup() {
      this.show = true;
    },

    //value=0改变省，1改变市，2改变区

    onProvince(picker, index, value) {
      let val = picker.getValues();
      let areaName = "";
      for (var i = 0; i < val.length; i++) {
        areaName = val[i].name;
      }
      this.carmodel = areaName.substr(0, areaName.length - 1);
    },
    //确定选择城市
    onConfirm(val) {
      console.log(val);
      if (val[1].code === "0") {
        this.carmodel = "全国";
        this.searchBoxBoby.cityId = "";
        this.tryAgainFirst();
        this.fetchData();
      } else {
        var _body = this.carmodel;
        console.log(_body);
        axios
          .post(URI + "/lianlianche-car/dCity/getByName?name=" + _body)
          .then(res => {
            this.loading = false;
            if (res.status == 0) {
              console.log(res);
              this.searchBoxBoby.cityId = res.data[0].cityId;
              this.tryAgainFirst();
              this.fetchData();
            } else {
              Toast(res.msg);
            }
          });
      }
      this.show = false; //关闭弹框
    },
    //取消选中城市
    onCancel() {
      this.show = false;
      this.$refs.myArea.reset(); // 重置城市列表
    },

    onShowSearchBox: function(conditional) {
      if (conditional == "brand") {
        /** */
        this.$router.push({
          name: "Brand",
          params: { pageSource: "BuyCar" }
        });
      }

      /**
       * @params conditional 当前点击是哪个排序框
       * 弹出条件搜索框
       */
      // console.log(sort, "sortsort");
      if (this.conditional == conditional) {
        this.conditional = "";
      } else {
        this.conditional = conditional;
      }
    },

    setConditional: function(value) {
      this.conditional = value;
    },

    onSearch: function(field) {
      // 搜索排序
      if (this.conditional) {
        if (field != null) {
          if (this.conditional == "sort") {
            //智能排序
            // this.searchBoxBoby = {
            //     [this.conditional]: field
            // };
            this.searchBoxBoby[this.conditional] = field;

            this.tryAgainFirst();
            this.fetchData();
          } else if (this.conditional == "price") {
            // this.searchBoxBoby = field;
            this.searchBoxBoby = Object.assign({}, this.searchBoxBoby, field);
            this.tryAgainFirst();
            this.fetchData();
          } else if (this.conditional == "multiselect") {
            /**
             * 自定义刷选
             */
            // 先把之前三个选择属性删除，再合并剩下的
            // delete this.searchBoxBoby.sort;
            // delete this.searchBoxBoby.minPrice;
            // delete this.searchBoxBoby.maxPrice;
            this.searchBoxBoby = Object.assign({}, this.searchBoxBoby, field);
          }
        } else {
          this.searchBoxBoby = {};
          this.fetchData();
        }
      }
    },

    onOk: function(type) {
      /**
       * 模态框有ok按钮的时候执行
       */
      this.conditional = "";
      if (type == "price") {
        // 如果是自定义输入价格
        this.searchBoxBoby = Object.assign(
          {},
          this.searchBoxBoby,
          this.customInput
        );
        // this.searchBoxBoby = this.customInput;
      }
      // 模糊搜索
      this.tryAgainFirst();
      this.fetchData();
    },

    onSearchs(val) {
      console.log(val);
      if (this.searchBoxBoby.keyword && this.searchBoxBoby.keyword.trim()) {
        this.searchBoxBoby.keyword = this.searchBoxBoby.keyword.trim();
      } else {
        delete this.searchBoxBoby.keyword;
      }
      this.tryAgainFirst();
      this.fetchData();
    },
    onReset: function() {
      /**
       * 重置刷选框里的选择条件
       */
      this.searchBoxBoby = {};
    },

    tryAgainFirst: function(type) {
      /**
       * 清空所有值，从新重第一页开始请求
       * 要把
       *  this.resList=[] 清空，应为feach里是用concat合并数组的方法进行的
       */
      this.body.pageNo = 1;
      this.resList = [];
    },

    fetchData: function() {
      this.loading = true;
      const { body, searchBoxBoby } = this;
      let _body = Object.assign({}, body, searchBoxBoby);
      console.log(_body);
      if (this.$route.query.phone) {
        _body.phone = this.$route.query.phone;
      } else {
        _body.phone = _body.phone;
      }
      if (this.$route.query.carBodyType) {
        _body.carBodyType = this.$route.query.carBodyType;
      } else {
        _body.carBodyType = _body.carBodyType;
      }
      if (this.$route.query.carBrandId) {
        _body.carBrandId = this.$route.query.carBrandId;
      } else {
        _body.carBrandId = _body.carBrandId;
      }
      if (this.$route.query.carGearboxType) {
        _body.carGearboxType = this.$route.query.carGearboxType;
      } else {
        _body.carGearboxType = _body.carGearboxType;
      }
      if (this.$route.query.sort) {
        _body.sort = this.$route.query.sort;
      } else {
        _body.sort = _body.sort;
      }
      if (this.$route.query.type) {
        _body.type = this.$route.query.type;
      } else {
        _body.type = _body.type;
      }
      if (this.$route.query.maxCarAge) {
        _body.maxCarAge = this.$route.query.maxCarAge;
      } else {
        _body.maxCarAge = _body.maxCarAge;
      }
      if (this.$route.query.minCarAge) {
        _body.minCarAge = this.$route.query.minCarAge;
      } else {
        _body.minCarAge = _body.minCarAge;
      }
      if (this.$route.query.maxPrice) {
        _body.maxPrice = this.$route.query.maxPrice;
      } else {
        _body.maxPrice = _body.maxPrice;
      }
      if (this.$route.query.minPrice) {
        _body.minPrice = this.$route.query.minPrice;
      } else {
        _body.minPrice = _body.minPrice;
      }
      if (this.$route.query.keyword) {
        _body.keyword = this.$route.query.keyword;
      } else {
        _body.keyword = _body.keyword;
      }
      if (this.$route.query.storeId) {
        _body.storeId = this.$route.query.storeId;
      } else {
        _body.storeId = _body.storeId;
      }
      if (this.$route.query.status) {
        _body.status = this.$route.query.status;
      } else {
        _body.status = _body.status;
      }
      if (this.$route.query.cityId) {
        _body.cityId = this.$route.query.cityId;
      } else {
        _body.cityId = _body.cityId;
      }
      API_GET("/search/car/page", _body).then(res => {
        this.loading = false;
        if (res.status == 0) {
          this.resList = [...this.resList, ...res.data.list];
          this.resTotal = res.data.total;
          this.lastPages = res.data.pages;
        } else {
          Toast(res.msg);
        }
      });
    },

    loadMore: function() {
      // this.loading = true;
      this.body.pageNo = this.body.pageNo + 1;
      if (this.body.pageNo > this.lastPages) {
        // Toast("已经是最后一页了");
        return;
      }
      this.fetchData();
    },

    linkCarInfo: function(item) {
      /**
       * 跳转到车辆详情页
       */
      console.log(this.phone);
      this.$router.push({
        name: "Details",
        params: { id: item.id ,phone: this.phone},
      });
    },

    mapPriceClassName: function(v, key) {
      if (this.conditional == "price") {
        if (
          this.searchBoxBoby.minPrice == v.minPrice &&
          this.searchBoxBoby.maxPrice == v.maxPrice
        ) {
          return "screen_current";
        }
      }
      if (this.conditional == "multiselect") {
        if (key == "carAge") {
          if (
            this.searchBoxBoby.carAgeStart == v.carAgeStart &&
            this.searchBoxBoby.carAgeEnd == v.carAgeEnd
          ) {
            return "screen_current";
          }
        } else {
          if (this.searchBoxBoby[key] === v[key]) {
            return "screen_current1";
          }
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #ffffff;
}
.mint-header {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyCar.vue